import callApi from 'common/callApi';

export const getFinancialSummary = () =>
  dispatch => dispatch(callApi(`v1/financial/summary`))
    .then(result => result.json());
